import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import Avatar from 'material-ui/Avatar';
import myPic from './static/images/me.jpg'
const styles = {
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  avatar: {
    right: 20,
    top:5,
    position:'fixed',
  },
};

function ImageAvatars(props) {
  const { classes } = props;
  return (
      <Avatar alt="Remy Sharp" src={myPic} className={classes.avatar} />
  );
}

ImageAvatars.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImageAvatars);


// WEBPACK FOOTER //
// ./src/avatar.js